export const IntercomSourceType = {
    BANNER: 'banner',
    WIDGET: 'widget',
    CONTACT_US_ADMIN: 'contact_us_admin',
};
//# sourceMappingURL=intercom.config.js.map